import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { baseCurrencyStore } from './baseCurrency';
import { sessionStore } from './session';
import { userStore } from './user';
import { userRolesStore } from './userRoles';

declare global {
  interface Window {
    taptap: Record<string, any>;
  }
}

type UserStore = ReturnType<typeof userStore>;
type UserRolesStore = ReturnType<typeof userRolesStore>;
type SessionStore = ReturnType<typeof sessionStore>;
type BaseCurrencyStore = ReturnType<typeof baseCurrencyStore>;
export type GlobalStore = UserStore & UserRolesStore & SessionStore & BaseCurrencyStore;

export const useGlobalStore = create<GlobalStore>()(
  devtools(
    (...a) => ({
      ...userStore(...a),
      ...userRolesStore(...a),
      ...sessionStore(...a),
      ...baseCurrencyStore(...a)
    }),
    { name: 'global' }
  )
);

export const getGlobalStore = () => useGlobalStore.getState();
